import React, { useState } from "react";
import { Image, Card } from "react-bootstrap";
import { IPUrl } from "../../commons/IPAddress";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Media from "../../components/Media";
import AllHeader from "../../components/AllHeader";
import Parent from "../../container/Parent";

function InternalNews() {
  const params = useParams();
  const [Id, setId] = useState(params.requestId);
  const location = useLocation();
  const { Tpe_F, Text, Tarikh, Pic, Tittle, Type } = location.state || {};

  const adjustedText = decodeURIComponent(Text).replace(
    /src="\/Content\/UserFiles\/([^"]+)"/g,
    `src="${IPUrl}/Content/UserFiles/$1"`
  ).replace(
    /src="\/https:\/\/www\.amol\.ir\/contentimages\/([^"]+)"/g,
    'src="https://www.amol.ir/contentimages/$1"'
  );

  // useEffect(() => {
  //   const axios = require("axios");
  //   axios.post(apiUrl + "GetNews", {
  //     Id: Id,
  //     Uid: UserID
  //   })
  //     .then((res) => {
  //       if (res.data.result === "true") {
  //         setSeenFile(res.data.data)
  //       } else {

  //       }
  //     });
  // }, [Id]);

  return (
    <div className="rgc-pages">
      <AllHeader>
        {/* <span>{data}</span> */}
        {/* {seenFile[0].Tittle} */}

        {(() => {
          switch (Type) {
            case 1:
              return <span>اخبار شهرداری</span>;

            case 2:
              return <span>اخبار شهروندی</span>;

            case 3:
              return <span>راهنمای شهروندی</span>;

            case 4:
              return <span>رویدادهای فرهنگی</span>;

            case 5:
              return <span>مصوبات شورا</span>;

            default:
              return <span> اخبار</span>;
          }
        })()}
      </AllHeader>
      <Parent>
        <div className="rgc-internal-news float-none float-md-start">
          {Type === 3 ? (
            <Image
              src={Pic}
              alt=""
              fluid
              className="img-fluid m-0 col-12 col-md-5 float-none float-md-start internal-news-img"
            />
          ) : Type == 2 ? (
            <Image
              src={"data:image/png;base64," + Pic}
              className="img-fluid m-0 col-12 col-md-5 float-none float-md-start internal-news-img"
            />
          ) : (
            <Image
              src={IPUrl + "/UploadedFile/Session/Ssn/" + Pic}
              className="img-fluid m-0 col-12 col-md-5 float-none float-md-start internal-news-img"
            />
          )}
          <Card.Body>
            <div className="meta-news d-flex">
              <ul>
                <li>
                  <i className="fa fa-calendar"></i>{" "}
                  <span className="text-meta"> {Tarikh}</span>
                </li>
                <li>
                  <i className="fa fa-folder"></i>{" "}
                  <span className="title-meta">دسته‌بندی: </span>{" "}
                  <span className="text-meta" itemprop="articleSection">
                    {Tpe_F}
                  </span>
                </li>

                {Type === 1 || Type === 2 ? ( //اخبار شهرداریو اخبار شهروندی
                  <li>
                    <i className="fa fa-newspaper"></i>{" "}
                    <span className="title-meta">کد خبر: </span>{" "}
                    <span className="text-meta">-</span>
                  </li>
                ) : (
                  ""
                )}

                {Type === 1 || Type === 2 ? (
                  <li>
                    <i className="fa fa-microphone"></i>{" "}
                    <span className="title-meta">شهروند خبرنگار :</span>{" "}
                    <span className="text-meta">{/* مهرداد اکبری */}</span>
                  </li>
                ) : (
                  ""
                )}
                {/* <li className="hidden-xs hidden-print">
                  <i className="fa fa-print"></i>
                  <span className="text-meta">چاپ</span>
                </li> */}

                <li>
                  <Media address={`/Internalnews/${Id}`} title={Tittle} />
                </li>
              </ul>
            </div>
            <Card.Title>{Tittle}</Card.Title>
            <Card.Text dangerouslySetInnerHTML={{ __html: adjustedText }}></Card.Text>
            {/* <Card.Text   
            dangerouslySetInnerHTML={{__html: decodeURIComponent(Text).replaceAll("/Content/UserFiles/",`${IPUrl}/Content/UserFiles/`),}}
            ></Card.Text> */}

            {/* social media */}
          </Card.Body>
        </div>
      </Parent>
    </div>
  );
}

export default InternalNews;
